<template>
  <div class="catalog">
    <div class="content">
      <div class="notbox" v-if="munelist.length == 0">
        <img src="../assets/blank/notlist.png" alt="" />
        <p class="inp">暂无课程目录</p>
      </div>
      <Menu
        v-else
        @todetail="todetail"
        :munelist="munelist"
        :catalogId="catalogId"
        :examAccess="examAccess"
        :menuId="menuId"
      ></Menu>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/common/Menu";
import { getcourseDetailApi, getupdateStatusApi } from "@/request/api";
export default {
  name: "catalog",
  components: { Menu },
  data() {
    return {
      catalogId: "",
      courseId: "",
      munelist: [],
      menuId: "",
      joined: "",
      isFree: "",
      chapterId: "",
      examAccess: "",
    };
  },
  created() {
    this.catalogId = JSON.parse(this.$Base64.decode(this.$route.query.id));
    if(this.$route.query.joined){
      this.joined = JSON.parse(this.$Base64.decode(this.$route.query.joined));
    }
    
    this.init();
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    isJoined() {
      return this.$store.state.isJoined;
    },
  },
  watch: {
    isLogin: function () {
      this.init();
    },
    isJoined: function (val) {
      this.joined = val;
    },
  },
  methods: {
    init() {
      this.getToken(getcourseDetailApi, { courseId: this.catalogId }, (res) => {
        // console.log(res)
        this.munelist = res.data.chapters;
        this.examAccess = res.data.examAccess;
        this.joined = res.data.joined;
        // console.log(this.joined)
      });
    },
    todetail(
      id,
      menuId,
      isFree,
      type,
      title,
      paperId,
      isFinished,
      isLogin,
      chapterId
    ) {
      if (this.joined) {
        if (isFinished == false) {
          if (type == 0 || type == 2) {
            this.$router.push({
              path: "/catalogDetail",
              query: {
                id:this.$Base64.encode(id),
                menuId:this.$Base64.encode(menuId),
                type:this.$Base64.encode(type),
                paperId:this.$Base64.encode(paperId),
                isFree:this.$Base64.encode(isFree),
                joined:this.$Base64.encode(this.joined),
                chapterId: this.$Base64.encode(chapterId),
              },
            });
          } else if (type == 3) {
            if (this.examAccess == false) {
              this.$message.error("必须先完成所有任务，才能进行考试！");
            } else {
              this.$router.push({
                path: "/catalogDetail",
                query: {
                id:this.$Base64.encode(id),
                menuId:this.$Base64.encode(menuId),
                type:this.$Base64.encode(type),
                paperId:this.$Base64.encode(paperId),
                isFree:this.$Base64.encode(isFree),
                joined:this.$Base64.encode(this.joined),
                chapterId: this.$Base64.encode(chapterId),
                },
              });
            }
          } else {
            this.getToken(
              getupdateStatusApi,
              { status: 1, courseId: id, taskId: menuId },
              () => {
                this.$store.commit("getIds", {
                  chapterId: this.chapterId,
                  taskId: id,
                });
                this.$router.push({
                  path: "/catalogDetail",
                  query: {
                   id:this.$Base64.encode(id),
                    menuId:this.$Base64.encode(menuId),
                    type:this.$Base64.encode(type),
                    paperId:this.$Base64.encode(paperId),
                    joined:this.$Base64.encode(this.joined),
                    chapterId: this.$Base64.encode(chapterId),
                  },
                });
              }
            );
          }
        } else {
          this.$router.push({
            path: "/catalogDetail",
            query: {
                id:this.$Base64.encode(id),
                menuId:this.$Base64.encode(menuId),
                type:this.$Base64.encode(type),
                paperId:this.$Base64.encode(paperId),
                isFree:this.$Base64.encode(isFree),
                joined:this.$Base64.encode(this.joined),
                chapterId: this.$Base64.encode(chapterId),
            },
          });
        }
      } else {
        if (isFree == 1) {
          this.$router.push({
            path: "/catalogDetail",
            query: {
            id:this.$Base64.encode(id),
            menuId:this.$Base64.encode(menuId),
            type:this.$Base64.encode(type),
            paperId:this.$Base64.encode(paperId),
            joined:this.$Base64.encode(this.joined),
            chapterId: this.$Base64.encode(chapterId),
            isFree:this.$Base64.encode(isFree),
            },
          });
        } else {
          if (isLogin == 0) {
            this.$message.info("你还没有加入此课程，请先加入！");
          } else {
            this.$message.info("你还没登录");
          }
        }
      }
    },
  },
};
</script>
<style >
.catalog .ant-menu-inline,
.catalog .ant-menu-vertical,
.catalog .ant-menu-vertical-left {
  border-right: 0;
}
.catalog .ant-menu-inline .ant-menu-submenu-title {
  margin-bottom: 0px;
}
.catalog .ant-menu .ant-menu-inline .ant-menu-root .ant-menu-light {
  width: 100%;
}
.catalog .ant-menu-submenu .ant-menu-submenu-inline {
  background-color: #f5f7fa;
}
.catalog .ant-menu-root.ant-menu-vertical,
.catalog .ant-menu-root.ant-menu-vertical-left,
.catalog .ant-menu-root.ant-menu-vertical-right,
.catalog .ant-menu-root.ant-menu-inline {
  -webkit-box-shadow: none;
  box-shadow: none;
  background: #fff;
  color: #333;
}
.catalog .ant-menu-vertical .ant-menu-submenu,
.catalog .ant-menu-vertical-left .ant-menu-submenu,
.catalog .ant-menu-vertical-right .ant-menu-submenu,
.catalog .ant-menu-inline .ant-menu-submenu {
  margin-bottom: 16px;
  background: #f5f7fa;
}
.catalog .ant-menu-sub.ant-menu-inline > .ant-menu-item,
.catalog
  .ant-menu-sub.ant-menu-inline
  > .ant-menu-submenu
  > .ant-menu-submenu-title {
  height: 45px;
  line-height: 45px;
  /* border-bottom: 1px dashed #e7e9ef; */
}
.catalog .ant-menu-sub.ant-menu-inline > .ant-menu-item,
.catalog
  .ant-menu-sub.ant-menu-inline
  > .ant-menu-submenu
  > .ant-menu-submenu-title:nth-child(1) {
  border-top: 1px dashed #e7e9ef;
}
.catalog .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #f8f8f8;
  color: #ef9545;
}
.catalog .ant-menu:not(.ant-menu-horizontal) .ant-menu-item:hover {
  background-color: #f8f8f8;
  color: #ef9545;
}
.catalog .ant-menu-vertical .ant-menu-item,
.catalog .ant-menu-vertical-left .ant-menu-item,
.catalog .ant-menu-vertical-right .ant-menu-item,
.catalog .ant-menu-inline .ant-menu-item,
.catalog .ant-menu-vertical .ant-menu-submenu-title,
.catalog .ant-menu-vertical-left .ant-menu-submenu-title,
.catalog .ant-menu-vertical-right .ant-menu-submenu-title,
.catalog .ant-menu-inline .ant-menu-submenu-title {
  height: 45px;
  padding: 0 16px;
  overflow: hidden;
  font-size: 16px;
  line-height: 45px;
  text-overflow: ellipsis;
}
.catalog .ant-menu-vertical .ant-menu-submenu,
.catalog .ant-menu-vertical-left .ant-menu-submenu,
.catalog .ant-menu-vertical-right .ant-menu-submenu,
.catalog .ant-menu-inline .ant-menu-submenu {
  margin-bottom: 16px;
  background: #f5f7fa;
}
.catalog .ant-menu-sub.ant-menu-inline > .ant-menu-item,
.catalog
  .ant-menu-sub.ant-menu-inline
  > .ant-menu-submenu
  > .ant-menu-submenu-title {
  height: 48px;
  line-height: 48px;
  font-size: 15px !important;
  list-style-position: inside;
  list-style-type: disc;
}
.catalog .ant-menu-vertical .ant-menu-item::after,
.catalog .ant-menu-vertical-left .ant-menu-item::after,
.catalog .ant-menu-vertical-right .ant-menu-item::after,
.catalog .ant-menu-inline .ant-menu-item::after {
  border-right: 0px;
  line-height: 48px;
}
.catalog .ant-menu-vertical .ant-menu-item:not(:last-child),
.catalog .ant-menu-vertical-left .ant-menu-item:not(:last-child),
.catalog .ant-menu-vertical-right .ant-menu-item:not(:last-child),
.catalog .ant-menu-inline .ant-menu-item:not(:last-child) {
  margin-bottom: 0px;
}
.catalog .ant-menu-vertical .ant-menu-item,
.catalog .ant-menu-vertical-left .ant-menu-item,
.catalog .ant-menu-vertical-right .ant-menu-item,
.catalog .ant-menu-inline .ant-menu-item,
.catalog .ant-menu-vertical .ant-menu-submenu-title,
.catalog .ant-menu-vertical-left .ant-menu-submenu-title,
.catalog .ant-menu-vertical-right .ant-menu-submenu-title,
.catalog .ant-menu-inline .ant-menu-submenu-title {
  height: 45px;
  margin-top: 0px;
  padding: 0 16px;
}
.catalog .ant-menu-vertical-right > .ant-menu-submenu > .ant-menu-submenu-title,
.catalog .ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 45px;
  line-height: 45px;
  padding-left: 16px !important;
}
.catalog .ant-menu-sub.ant-menu-inline > .ant-menu-item,
.catalog
  .ant-menu-sub.ant-menu-inline
  > .ant-menu-submenu
  > .ant-menu-submenu-title {
  height: 48px;
  line-height: 48px;
  list-style-position: inside;
  list-style-type: disc;
  padding-left: 25px !important;
}
</style>
<style lang="stylus" scoped>
.catalog {
  .content {
    width: 875px;
    min-height: 300px;
  }

  .notbox {
    margin: 0 auto;
    margin-bottom: 30px;
    margin-top: 40px;
    text-align: center;

    img {
      display: block;
      margin: 0 auto;
    }

    .inp {
      font-size: 18px;
      color: #666;
      margin: 0 auto;
      text-align: center;
      margin-top: 10px;
    }
  }
}
</style>
